import FeatureCards from "../FeatureCards/FeatureCards";
import Logo from "../../Assets/images/aboutUsLogo.jpg"

export const AboutUsSection = () => {
    return (
        <div style={{
            backgroundColor: '#f8f9fa',
            padding: '80px 20px',
            position: 'relative',
            overflow: 'hidden'
        }}>
            <div className="container">
                <div className="row align-items-center g-5" dir="rtl">
                    {/* Logo Side */}
                    <div className="col-lg-5 text-center">
                        <div style={{
                            backgroundColor: 'white',
                            borderRadius: '30px',
                            padding: '30px',
                            boxShadow: '0 15px 50px rgba(13, 32, 58, 0.1)',
                            position: 'relative'
                        }}>
                            <div style={{
                                width: '100%',
                                height: '100%',
                                margin: '0 auto',
                                backgroundColor: '#0d203a',
                                borderRadius: '30px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                position: 'relative',
                                overflow: 'hidden'
                            }}>
                                <img src={Logo} alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'cover', margin: '0 auto' }} />
                            </div>
                            <div style={{
                                position: 'absolute',
                                top: '20px',
                                right: '20px',
                                width: '60px',
                                height: '60px',
                                backgroundColor: '#3b82f6',
                                borderRadius: '50%',
                                opacity: '0.1'
                            }}></div>
                            <div style={{
                                position: 'absolute',
                                bottom: '30px',
                                left: '30px',
                                width: '40px',
                                height: '40px',
                                backgroundColor: '#0d203a',
                                borderRadius: '50%',
                                opacity: '0.1'
                            }}></div>
                        </div>
                    </div>

                    {/* Content Side */}
                    <div className="col-lg-7">
                        <h2 style={{
                            color: '#3b82f6',
                            fontSize: '2.8rem',
                            fontWeight: 'bold',
                            marginBottom: '20px',
                            position: 'relative',
                            display: 'inline-block'
                        }}>
                            مين سمارت تريند ؟
                            <span style={{
                                position: 'absolute',
                                bottom: '-10px',
                                right: '0',
                                width: '60%',
                                height: '4px',
                                backgroundColor: '#3b82f6',
                                borderRadius: '2px'
                            }}></span>
                        </h2>

                        <p style={{
                            color: '#0d203a',
                            fontSize: '1.2rem',
                            lineHeight: '2',
                            textAlign: 'justify',
                            marginTop: '30px',
                            fontWeight: '500'
                        }}>
                            منصة إلكترونية مجانية تقدم خدمات الرعاية الصحية (الخدمات الطبية والأشعة التشخيصية)، ويتوفر لدينا الحجز والدفع الإلكتروني (طرق دفع متعددة)، للمساهمة في خفض تكاليف الخدمة، من خلال شبكة تتكون من العديد من أشهر مقدمي الخدمة الطبية من معامل تحاليل طبية ومراكز أشعة بجميع محافظات مصر، تتيح منصة سمارت تريند حجز الخدمات الطبية لنفسك أو للأخرين بخصومات تصل إلي 50%، كما تتيح أيضا مقارنة الأسعار بين مقدمي الخدمات الطبية المختلفة وإختيار الأنسب من حيث السعر والتقييم والخدمات.
                        </p>

                        {/* Features Icons */}

                    </div>
                </div>
            </div>
            <FeatureCards />
        </div>
    );
};

